import GlobalDataCacheDTO from 'dto/system/globalDataCacheDTO';
import GlobalDataCache from 'models/globalDataCache/globalDataCache';
import { mapFromRoles } from './roleMapping';
import { mapFromSettings } from './settingMapping';
import { mapFromUserSettings } from './userSettingMapping';
import { mapFromUsers } from './userMapping';

export function mapFromGlobalDataCache(globalDataCacheDTO: GlobalDataCacheDTO | undefined): GlobalDataCache {
  const globalDataCache = new GlobalDataCache();

  if (globalDataCacheDTO) {
    globalDataCache.settings = mapFromSettings(globalDataCacheDTO.settings);
    globalDataCache.userSettings = mapFromUserSettings(globalDataCacheDTO.userSettings);
    globalDataCache.users.items = mapFromUsers(globalDataCacheDTO.users);
    globalDataCache.roles.items = mapFromRoles(globalDataCacheDTO.roles);
  }

  return globalDataCache;
}
